export const COLOR = {
  TEXT_ICON_PRIMARY: '--color-text-icon-primary',
  TEXT_ICON_SECONDARY: '--color-text-icon-secondary',
  TEXT_ICON_TERTIARY: '--color-text-icon-tertiary',
  TEXT_ICON_CONSTANT_LIGHT: '--color-text-icon-constant-light',
  TEXT_ICON_CONSTANT_DARK: '--color-text-icon-constant-dark',

  ADDITIONAL_RED: '--color-additional-red',
  ADDITIONAL_RED_2: '--color-additional-red-2',
  ADDITIONAL_RED_3: '--color-additional-red-3',
  ADDITIONAL_ORANGE: '--color-additional-orange',
  ADDITIONAL_ORANGE_2: '--color-additional-orange-2',
  ADDITIONAL_ORANGE_3: '--color-additional-orange-3',
  ADDITIONAL_GREEN: '--color-additional-green',
  ADDITIONAL_PURPLE: '--color-additional-purple',
  ADDITIONAL_BLUE: '--color-additional-blue',
  ADDITIONAL_BLUE_2: '--color-additional-blue-2',

  SUBTITLE_WHITE: '--color-subtitle-white',
  SUBTITLE_BLUE: '--color-subtitle-blue',
  SUBTITLE_GREEN: '--color-subtitle-green',
  SUBTITLE_MAGENTA: '--color-subtitle-magenta',
  SUBTITLE_YELLOW: '--color-subtitle-yellow',
  SUBTITLE_RED: '--color-subtitle-red',
  SUBTITLE_LIGHT: '--color-subtitle-light',
  SUBTITLE_BLACK: '--color-subtitle-black',
  SUBTITLE_CYAN: '--color-subtitle-cyan',

  BASE_MAIN_DEFAULT: '--color-base-main-default',
  BASE_MAIN_PRESSED: '--color-base-main-pressed',
  MAIN_GRADIENT_90: '--color-main-gradient-90',
  MAIN_GRADIENT_0: '--color-main-gradient-0',
  MAIN_GRADIENT_180: '--color-main-gradient-180',
  MAIN_GRADIENT_270: '--color-main-gradient-270',
  BUNDLE_LAYOUT_OVERLAY: '--color-bundle-layout-overlay',
  TOA_LAYOUT_OVERLAY: '--color-toa-layout-overlay',
  ROW_MAIN_GRADIENT_0: '--color-row-main-gradient-0',
  ROW_MAIN_GRADIENT_1: '--color-row-main-gradient-1',
  ROW_MAIN_GRADIENT_2: '--color-row-main-gradient-2',

  SURFACE_DARK: '--color-surface-dark',
  SURFACE_DARK_2: '--color-surface-dark-2',
  SURFACE_DARK_3: '--color-surface-dark-3',
  SURFACE_DARK_4: '--color-surface-dark-4',
  SURFACE_DARK_7: '--color-surface-dark-7',
  SURFACE_DARK_6: '--color-surface-dark-6',
  SURFACE_DARK_5: '--color-surface-dark-5',
  SURFACE_LIGHT_1: '--color-surface-light-1',
  SURFACE_LIGHT_2: '--color-surface-light-2',
  SURFACE_CONSTANT_LIGHT: '--color-surface-constant-light',

  BORDER_SECONDARY: '--color-border-secondary',

  PROGRESS_BAR_ACCENT_SECONDARY: '--color-progress-bar-accent-secondary',
  ACCENT_SECONDARY: '--color-accent-secondary',
  ACCENT_PRIMARY_PRESSED: '--color-accent-primary-pressed',
  ACCENT_PRIMARY_PRESSED_OVERLAY: '--color-accent-primary-pressed-overlay',
  ACCENT_PRIMARY_HOVERED_OVERLAY: '--color-accent-primary-hovered-overlay',
  ACCENT_PRIMARY_DISABLED_OVERLAY: '--color-accent-primary-disabled-overlay',
  ACCENT_PRIMARY_GRADIENT: '--color-accent-primary-gradient',
  BUTTON_ACCENT_PRIMARY: '--color-button-accent-primary',
  BUTTON_ACCENT_PRIMARY_GRADIENT: '--color-button-accent-primary-gradient',
  CATEGORY_CARD_ACCENT_PRIMARY_GRADIENT:
    '--category-card-accent-primary-gradient',
  ACCENT_TERTIARY: '--color-accent-tertiary',

  ACCENT_WARNINGS_HOVERED: '--color-accent-warnings-hovered',
  ACCENT_WARNINGS_PRESSED: '--color-accent-warnings-pressed',

  DISABLED: '--color-disabled',

  // @TODO: Refactor naming

  SURFACE_OPACITY_LIGHT_10: '--color-surface-opacity-10',
  SURFACE_OPACITY_LIGHT_15: '--color-surface-opacity-15',
  SURFACE_OPACITY_LIGHT_20: '--color-surface-opacity-20',
  TRANSPARENT: '--color-transparent',

  SURFACE_OPACITY_DARK_25: '--color-surface-opacity-dark-25',
  SURFACE_OPACITY_DARK_40: '--color-surface-opacity-dark-40',
  SURFACE_OPACITY_DARK_50: '--color-surface-opacity-dark-50',
  SURFACE_OPACITY_DARK_60: '--color-surface-opacity-dark-60',
  SURFACE_OPACITY_DARK_70: '--color-surface-opacity-dark-70',
  SURFACE_OPACITY_DARK_80: '--color-surface-opacity-dark-80',

  OVERLAY_DEFAULT: '--color-overlay-default',
  OVERLAY_HOVERED: '--color-overlay-hovered',
  OVERLAY_PRESSED: '--color-overlay-pressed',

  CARD_VERTICAL_OVERLAY: '--color-card-vertical-overlay',
  EPISODE_CARD_VERTICAL_OVERLAY: '--color-episode-card-vertical-overlay',
  EVENT_CARD_VERTICAL_OVERLAY: '--color-event-card-vertical-overlay',

  OVERLAY_SHADOW: '--color-overlay-shadow',

  BANNER_HORIZONTAL_OVERLAY: '--color-banner-horizontal-overlay',
  BANNER_VERTICAL_OVERLAY: '--color-banner-vertical-overlay',
  BANNER_DETAILS_HORIZONTAL_OVERLAY:
    '--color-banner-details-horizontal-overlay',
  BANNER_DETAILS_VERTICAL_OVERLAY: '--color-banner-details-vertical-overlay',
  BANNER_SKELETON_BOTTOM_FADE: '--color-banner-skeleton-bottom-fade',
  SKELETON_SHINE_GRADIENT: '--color-skeleton-shine-gradient',
  LOGIN_VERTICAL_OVERLAY: '--color-login-vertical-overlay',
  PLAYER_VERTICAL_OVERLAY: '--color-player-vertical-overlay',
  BACKGROUND_VERTICAL_OVERLAY: '--color-background-vertical-overlay',
  BANNER_PARTIAL_HORIZONTAL_OVERLAY:
    '--color-banner-partial-horizontal-overlay',

  BACKGROUND_DARK: '--color-background-dark',
  BACKGROUND_DARK_APP: '--color-background-dark-app',
  BACKGROUND_GRAY: '--color-background-gray',
  BACKGROUND_DARK_EPG: '--color-background-dark-epg',
  BACKGROUND_PROGRAM_CARD: '--color-background-program-card',

  PROGRESS_LINE_OVERLAY: '--color-progress-line-overlay',
} as const
export type COLOR = (typeof COLOR)[keyof typeof COLOR]
